import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'templates'
const verb = 'get'

export default class OspreyTemplatesMetadata extends BaseAction {
    constructor() {
        const id = 'fea48905-d8d2-4c1f-9179-1dcb70ad4cfe'
        const path = `/${resource}/metadata`
        super(resource, verb, path, id)
        this.noCache = false
    }

    getMetadata(fields) {
        if (!fields) {
            fields = ['base', 'template']
        }

        if (Array.isArray(fields)) {
            fields = fields.join(',')
        }

        this.params = {
            fields
        }

        return fetchContentIfNeeded(this)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/templates/templates-metadata.js